export var IRetailerLaunchWithFaire;
(function (IRetailerLaunchWithFaire) {
    let Status;
    (function (Status) {
        Status["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
        Status["ELIGIBLE"] = "ELIGIBLE";
        Status["APPLIED"] = "APPLIED";
        Status["ACCEPTED"] = "ACCEPTED";
        Status["REJECTED"] = "REJECTED";
        Status["EXPIRED"] = "EXPIRED";
        Status["APPLICATION_IN_PROGRESS"] = "APPLICATION_IN_PROGRESS";
        Status["ON_HOLD"] = "ON_HOLD";
        Status["ON_HOLD_NO_LEASE"] = "ON_HOLD_NO_LEASE";
    })(Status = IRetailerLaunchWithFaire.Status || (IRetailerLaunchWithFaire.Status = {}));
    let ApplicationType;
    (function (ApplicationType) {
        ApplicationType["APPLICATION_TYPE_UNKNOWN"] = "APPLICATION_TYPE_UNKNOWN";
        ApplicationType["SOFT_CREDIT_CHECK"] = "SOFT_CREDIT_CHECK";
        ApplicationType["PRE_QUALIFIED"] = "PRE_QUALIFIED";
        ApplicationType["IDV_CONFIRMED"] = "IDV_CONFIRMED";
        ApplicationType["OWF_AND_GRANTS"] = "OWF_AND_GRANTS";
    })(ApplicationType = IRetailerLaunchWithFaire.ApplicationType || (IRetailerLaunchWithFaire.ApplicationType = {}));
    /**
     * Return an instance of IRetailerLaunchWithFaire with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IRetailerLaunchWithFaire.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IRetailerLaunchWithFaire || (IRetailerLaunchWithFaire = {}));
